import envService from './envService';

export interface ConfigOdsData {
  config_id: string;
  fiscal_year: number;
  seq: number;
  usage_more: number;
  time_to_email: string;
  email_admin: string;
  effective_date: string;
  expire_date: string | null;
  status: string;
  created_date: string;
  updated_date: string;
  created_by: string;
  updated_by: string;
  deleted_date: string | null;
  deleted_by: string | null;
  permission_data: string;
}

const API_BASE_URL = envService.getApiBaseUrl();

const CONFIG_ODS_ENDPOINTS = {
  activeSingle: `${API_BASE_URL}/api/config-ods/active-single`
} as const;

export async function getActiveConfig(): Promise<ConfigOdsData> {
  try {
    const response = await fetch(CONFIG_ODS_ENDPOINTS.activeSingle, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: ConfigOdsData = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching active config:', error);
    throw error;
  }
}
